import { FileProtectOutlined } from '@ant-design/icons';
import { FileRow } from '@framework/ui';
import { UploadFile } from 'antd';
import React from 'react';

export interface ISignedModuleFileRowProps {
  file: UploadFile | null | undefined;
  submissionId: string | null | undefined;
  submissionModuleId: string | null | undefined;
}

export function SignedModuleFileRow(props: ISignedModuleFileRowProps) {
  const { file, submissionId, submissionModuleId } = props;

  if (!file) return null;

  if (!submissionId || !submissionModuleId) {
    return null;
  }

  return (
    <FileRow
      file={file}
      icon={<FileProtectOutlined aria-hidden />}
      // downloadButton={
      //   <SignedModuleFileDownloadButton
      //     submissionId={submissionId}
      //     submissionModuleId={submissionModuleId}
      //   />
      // }
      //   La delete non è prevista
      //   deleteButton={}
    />
  );
}
